export enum SidebarNavItem {
    welcome = "welcome",
    orders = "orders",
    documents = "documents",
    account = "account",
    settings = "settings",
    favorites = "favorites",
}

export enum MyAccountTab {
    contact = "contact-info",
    changePassword = "change-password",
}
export enum MyCompanyTab {
    company = "company-info",
    teamMembers = "team-members",
    deliveryAddress = "delivery-address",
    financialRecords = "financial-records",
    companyProfile = "company-profile",
}

// export default SidebarNavItem;
